import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { useHooksAuth } from "../../hooks";
import { GlobalContext } from "../../contexts/GlobalContext";

export function CustomHeader({ onToggleSidebar }) {
    const { logout } = useHooksAuth();
    const { isDarkMode, toggleDarkMode } = useContext(GlobalContext);

    return (
        <header className="app-header">
            <div className="d-flex align-items-center gap-3">
                <button
                    onClick={onToggleSidebar}
                    className="header-btn"
                    title="Menu"
                >
                    <i className="fas fa-bars text-primary"></i>
                </button>
                <Link
                    to="/"
                    className="header-brand-link"
                >
                    DIST. <span>"DELDIA"</span>
                </Link>
            </div>

            <div className="d-flex align-items-center gap-3">
                <button
                    onClick={toggleDarkMode}
                    className="header-btn"
                    title={isDarkMode ? "Modo claro" : "Modo oscuro"}
                >
                    <i
                        className={`fas ${isDarkMode ? "fa-sun text-warning" : "fa-moon text-primary"}`}
                        style={{ fontSize: "1.1rem" }}
                    ></i>
                </button>

                <button
                    onClick={logout}
                    className="header-btn logout-btn"
                    title="Cerrar sesión"
                >
                    <i className="fas fa-sign-out-alt"></i>
                    <span>Cerrar sesión</span>
                </button>
            </div>
        </header>
    );
}

